
<!--<app-alerts></app-alerts>-->
<main>
  <ng-container *ngIf="aboutInfoReady">
    <section>
      <div class="container-fluid ptb-42">
        <div class="row">
          <div class="col-auto">
            <div class="titles-bdr-r">
              <h1 class="color-primary fs-325remTitles">{{aboutInfo.Titulo_Pagina}}</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container pb-120 gx-5 gx-lg-0">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-12 order-lg-0 order-2">
            <img src="{{aboutInfo.Imagem_Sobre_Nos.url}}" class="img-fluid img-escudo mx-auto" alt="Imagem Linhas - Transportes do Douro, Tâmega e Sousa">
          </div>
          <div class="col-lg-6 col-12 order-lg-0 order-1 my-auto">
            <h3>{{aboutInfo.Titulo_Seccao}}</h3>
            <h5 class="mb-3">{{aboutInfo.Subtitulo_Seccao}}</h5>
            <p [innerHTML]="aboutInfo.Texto_Seccao"></p>
          </div>
        </div>
      </div>
    </section>
  </ng-container>
</main>

